import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { AddressDisplay } from './AddressDisplay';

const AddressDisplayBridge = react2angular(AddressDisplay, [
  'data'
]);

export default AddressDisplayBridge;
